import React from "react";
import PropTypes from "prop-types";
import { Grid, GridItem, Select } from "@sainsburys-tech/fable";

const IoZoneFormSection = props => {
  const pinGroupOptions = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" }
  ];

  return (
    <section>
      <Grid cols={{ xl: 2, lg: 3, md: 5, sm: 1, xs: 1 }}>
        <GridItem colSpan={{ xl: 1, lg: 2, md: 4, sm: 1, xs: 1 }}>
          <h3 className="fable:mb-4">Assign pin group</h3>
          <p>
            Assign the unique pin number to the lighting zone to map the
            lighting zone to the gateway.
          </p>
        </GridItem>
      </Grid>
      <Grid cols={{ xl: 4, lg: 3, md: 5, sm: 2, xs: 1 }}>
        <GridItem colSpan={{ xl: 1, lg: 1, md: 2, sm: 1, xs: 1 }}>
          <Select
            name="pinId"
            label="Select pin group"
            options={pinGroupOptions}
            value={props.form.values.pinId}
            status={props.form.touched.pinId && props.form.errors.pinId ? "error" : undefined}
            onBlur={props.form.handleBlur}
            onChange={(value) => {
              props.form.setFieldValue("pinId", value);
            }}
          />
        </GridItem>
      </Grid>
    </section>
  );
};

IoZoneFormSection.propTypes = {
  form: PropTypes.object
};

export default IoZoneFormSection;
